import { useEffect, useState } from "react";
import { useAmbassadorSnapshot, getNationalCrews } from "@/lib/ambassadors/ambassadorEngine";

function buildBeats(): string[] {
  const crews = getNationalCrews();
  if (!crews.length) return ["🌎 La comunidad mundial explota"];
  const [top, second] = crews;
  return [
    `🔥 ${top.name} está creciendo`,
    `⚠️ ${top.name} lidera creators`,
    `💥 ${second?.name ?? top.name} domina referrals`,
    `🌎 La comunidad mundial explota`,
  ];
}

export function CommunityEnergyTicker() {
  useAmbassadorSnapshot();
  const [i, setI] = useState(0);
  const beats = buildBeats();
  useEffect(() => {
    const id = window.setInterval(() => setI((v) => (v + 1) % beats.length), 3800);
    return () => window.clearInterval(id);
  }, [beats.length]);
  const beat = beats[i % beats.length];
  return (
    <div
      className="overflow-hidden rounded-full border border-border/60 bg-background/70 px-3 py-1.5 text-[11px] font-bold backdrop-blur"
      aria-live="polite"
    >
      <span key={beat} className="inline-block animate-in fade-in slide-in-from-bottom-1">
        {beat}
      </span>
    </div>
  );
}
